export default __webpack_public_path__ + "static/media/runkeeper-interval-before-1.22135184.jpg";